import React, { useState, useEffect } from 'react'

import { string } from 'prop-types'

import { newHomepageService } from 'Pods/NewHomepage/Services/newHomepageService'

import PrintModelsBase from './components/PrintModelsBase'

function TrendingPrintModels({ title, mobileTitle = '', description, link, className = '', buttonText }) {
  const [models, setModels] = useState([])

  useEffect(() => {
    let isMounted = true
    const fetchTrendingModels = async () => {
      try {
        const trendingModels = await newHomepageService.getPrintTrendingModels(10)

        if (isMounted && Array.isArray(trendingModels)) {
          setModels(trendingModels)
        }
      } catch (error) {
        if (isMounted) {
          setModels([])
        }
      }
    }

    fetchTrendingModels()

    return () => {
      isMounted = false
    }
  }, [])

  return (
    <PrintModelsBase
      models={models}
      title={title}
      mobileTitle={mobileTitle}
      description={description}
      link={link}
      className={className}
      buttonText={buttonText}
    />
  )
}

TrendingPrintModels.propTypes = {
  title: string.isRequired,
  mobileTitle: string,
  description: string.isRequired,
  link: string.isRequired,
  className: string,
  buttonText: string.isRequired,
}

export default TrendingPrintModels
